<template>
  <div class="layout--main" :class="[
    layoutTypeClass,
    navbarClasses,
    footerClasses,
    { 'no-scroll': isAppPage, 'is-shop-page': isShopPage },
  ]">

    <v-nav-menu v-if="
      $store.state.AppActiveUser.userType === 'subClinic' ||
      $store.state.AppActiveUser.userType === 'clinic' ||
      ($store.state.AppActiveUser.userType === 'clinic' &&
        $store.state.AppActiveUser.financialDetails &&
        $store.state.AppActiveUser.financialDetails.accountNumber) ||
      ($store.state.AppActiveUser.userType === 'clinic' &&
        $store.state.AppActiveUser.defaultPaymentMethod === 'CreditCard' &&
        $store.state.AppActiveUser.paymentDetails.cardId)
    " :navMenuItems="editedNavMenuItems" title="Fresh Clinic" parent=".layout--main"
      dashboardRoute="/clinic/dashboard" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />
      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal :navbarType="navbarType" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" :navMenuItems="editedNavMenuItems" />
      </template>

      <template v-else>
        <the-clinic-navbar-vertical :navbarColor="navbarColor" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <go-to-v2-banner />
            <transition :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                class="router-header flex flex-wrap items-center mb-6">

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route"
                  :isRTL="$vs.rtl" :orderApprovalFlowEnabled="orderApprovalFlowEnabled" />
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
                v-if="!hideScrollToTop && !isShopPage">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="
                  (classesStr) => $emit('setAppClasses', classesStr)
                " />
              </transition>
            </div>
          </div>
        </div>
        <the-footer />
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop';
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue';
import navMenuItems from '@/layouts/components/vertical-nav-menu/clinic/ClinicNavMenuItems.js';

import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue';
import TheClinicNavbarVertical from '@/layouts/components/navbar/clinic/TheclinicNavbarVertical.vue';
import TheFooter from '@/layouts/components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue';
import GoToV2Banner from '@/layouts/components/go-to-v2-banner/GoToV2Banner.vue';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { isClinicOrderApprovalFlowEnabled } from '@/globalHelpers/storeHelper';
import { isShopRoute } from '@/utils/isShopRoute';



export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheClinicNavbarVertical,
    VNavMenu,
    GoToV2Banner,
  },
  data() {
    return {
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems: navMenuItems,
      editedNavMenuItems: [],
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      steps: [
        {
          target: '#btnVNavMenuMinToggler',
          content: 'Toggle Collapse Sidebar.',
        },
        {
          target: '.vx-navbar__starred-pages',
          content:
            'Create your own bookmarks. You can also re-arrange them using drag & drop.',
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.',
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.',
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based on your preference',
          params: {
            placement: 'left',
          },
        },
        {
          target: '.vs-button.buy-now',
          content: 'Buy this awesomeness at affordable price!',
          params: {
            placement: 'top',
          },
        },
      ],
      orderApprovalFlowEnabled: null,
    };
  },
  watch: {
    isFranchiseClinic(newVal, oldVal) {
      if (newVal !== undefined && newVal !== oldVal) {
        const settingNav = navMenuItems.find(
          ({ name }) => name === 'clinicSettings'
        );
        if (settingNav) {
          if (!newVal) {
            settingNav.items.push(
              {
                url: '/clinic/settings/products-list',
                name: 'Clinic Products List',
                slug: 'clinic-products-list',
                icon: 'StarIcon',
                i18n: 'Product Lists',
              },
              {
                url: '/clinic/settings/treatment-areas',
                name: 'Clinic Treatment Areas',
                slug: 'clinic-treatment-areas',
                icon: 'StarIcon',
                i18n: 'Treatment Areas',
              }
            );
          } else {
            settingNav.items = [
              {
                url: '/clinic/settings/doctor-rate',
                name: 'Doctor Rate',
                icon: 'StarIcon',
                slug: 'doctor-rate',
                i18n: 'Doctor Rate',
              },
            ];
          }
        }
      }
    },
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      const user = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
      );
      const subFranchiseMenu = navMenuItems.find(
        ({ name }) => name === 'SubClinic'
      );
      if (user.userType === 'clinic') {
        if (!subFranchiseMenu) {
          navMenuItems.splice(navMenuItems.length - 2, 1, {
            url: '/clinic/admin',
            name: 'SubClinic',
            icon: 'PackageIcon',
            slug: 'sub-clinic-management',
            i18n: 'Admin Management',
          });
        }
      } else {
        if (subFranchiseMenu) {
          navMenuItems.splice(
            navMenuItems.findIndex(({ name }) => name === 'SubClinic'),
            1
          );
        }
      }
    },
    isThemeDark(val) {
      const color = this.navbarColor == '#fff' && val ? '#10163a' : '#fff';
      this.updateNavbarColor(color);
    },
    '$store.state.mainLayoutType'(val) {
      this.setNavMenuVisibility(val);
      this.disableThemeTour = true;
    },
    '$store.state.AppActiveUser.financialDetails.accountNumber'(
      newVal,
      oldVal
    ) {
      const user = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
      );
      if (
        user.userType === 'clinic' &&
        newVal !== oldVal &&
        typeof newVal === 'undefined'
      ) {
        const link = document.createElement('a');
        link.href = '/clinic/setup-bank-detail';
        link.click();
      }
    },
  },
  computed: {
    isShopPage() {
      return isShopRoute(this.$route && this.$route.path);
    },
    ...mapGetters('clinic', ['isFranchiseClinic']),
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (
        this.$store.state.AppActiveUser.userType === 'subClinic' ||
        this.$store.state.AppActiveUser.userType === 'clinic' ||
        (this.$store.state.AppActiveUser.userType === 'clinic' &&
          this.$store.state.AppActiveUser.financialDetails &&
          this.$store.state.AppActiveUser.financialDetails.accountNumber) ||
        (this.$store.state.AppActiveUser.userType === 'clinic' &&
          this.$store.state.AppActiveUser.defaultPaymentMethod ===
          'CreditCard' &&
          this.$store.state.AppActiveUser.paymentDetails.cardId)
      ) {
        if (this.mainLayoutType === 'vertical') {
          if (this.verticalNavMenuWidth == 'default')
            return 'content-area-reduced';
          else if (this.verticalNavMenuWidth == 'reduced')
            return 'content-area-lg';
          else return 'content-area-full';
        }
        // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
        else return 'content-area-full';
      } else return 'content-area-full';
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark';
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  beforeMount() {
    this.init();
  },

  async mounted() {
    const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');

    try {
      this.orderApprovalFlowEnabled = await isClinicOrderApprovalFlowEnabled(clinicId);
    } catch (error) {
      console.error('Error fetching clinic details:', error);
      this.orderApprovalFlowEnabled = false;
    }
  },

  methods: {
    init() {
      this.editedNavMenuItems = _.pull(
        _.cloneDeep(navMenuItems).map((item) => {
          if (!item.items) {
            return item;
          } else {
            item.items = _.pull(
              item.items.map((subitem) => {
                if (subitem.slug === 'shop') {
                  return subitem;
                }
                return subitem;
              }),
              undefined
            );
            if (item.items.length) {
              return item;
            }
          }
        }),
        undefined
      );
    },
    async checkIfFranchiseClinic() {
      await this.$store.dispatch('clinic/checkIfFranchiseClinic');
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == 'static')
        this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff');
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == '#fff') this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === 'horizontal' && this.windowWidth >= 1200) ||
        (layoutType === 'vertical' && this.windowWidth < 1200)
      ) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
  },
  created() {
    this.checkIfFranchiseClinic();
    const color =
      this.navbarColor == '#fff' && this.isThemeDark
        ? '#10163a'
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);

    // Dynamic Watchers for tour
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch(
      '$store.state.windowWidth',
      (val) => {
        if (val < 1200) {
          this.disableThemeTour = true;
          this.dynamicWatchers.windowWidth();
        }
      }
    );

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch(
      '$store.state.verticalNavMenuWidth',
      () => {
        this.disableThemeTour = true;
        this.dynamicWatchers.verticalNavMenuWidth();
      }
    );

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true;
      this.dynamicWatchers.rtl();
    });

    const subFranchiseMenu = navMenuItems.find(
      ({ name }) => name === 'SubClinic'
    );
    if (subFranchiseMenu) {
      navMenuItems.splice(
        navMenuItems.findIndex(({ name }) => name === 'SubClinic'),
        1
      );
    }
  },
  beforeDestroy() {
    Object.keys(this.dynamicWatchers).map((i) => {
      this.dynamicWatchers[i]();
      delete this.dynamicWatchers[i];
    });
  },
};
</script>
